<template>
<!-- 新闻详情 -->
    <div>
        <!-- 图片 -->
        <div class="topImg"> 
            <span>
                新闻动态
            </span>
        </div>
        <div class="newsContentDiv">
            <div class="newsContentInfo">
                <div class="newsCrumbs">
                    <span class="nct ahref"><router-link to='/homePage'>首页</router-link></span>
                    <!-- <span class="nct">新闻动态</span> -->
                    <span class="nct ahref"><router-link to='/dynamicNews/companyNews'>公司新闻</router-link></span>
                    <span class="nct">正文</span>
                </div>
                <div class="news">
                    <div>
                        <span>发布时间：{{currentObj.newsDate}}</span>
                        <span class="nleft">浏览人数：{{currentObj.views}}次</span>
                        <span class="nleft">新闻来源：胤石科技</span>
                    </div>
                </div>
                <div class="newsContent">
                    <div class="title">{{currentObj.title}}</div>
                    <div class="content">
                        <span v-html="currentObj.newsContent"></span>
                    </div>
                    <div class="pages">
                        <div>上一篇：
                            <span>
                                <a v-if="upObj.title" class="pagesColor" @click="newInfoClick(upObj.id)">{{upObj.title}}</a>
                                <a v-else>暂无数据！</a>
                            </span>
                        </div>
                        <div>下一篇：
                            <span>
                                <a v-if="downObj.title" class="pagesColor" @click="newInfoClick(downObj.id)">{{downObj.title}}</a>
                                <a v-else>暂无数据！</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getNews,incrementalViews} from '@/api'
import { mapMutations } from 'vuex'

export default {
    name: 'YinshiOffcialwebsiteNewsDetails',
    data() {
        return {
            ist:true,
            isNo:false,
            // 传过来的id
            id:0,
            // 上一篇
            upObj:{},
            // 当前
            currentObj:{},
            // 下一篇
            downObj:{}
        };
    },

    mounted() {
        
    },

    methods: {
        ...mapMutations(['GoTop']),
        // 上下一篇点击
        async newInfoClick(id){
            await incrementalViews(id)
            this.selectNewsId(id)
            this.GoTop(600)
        },
        // 根据id查询新闻详情
        async selectNewsId(id,num){
            // 获取新闻详情，和上下篇
            let res = await getNews(id)
            if(res.code == 200){
                var newIdx = res.data.findIndex(item => item.id == id);
                if(res.data.length == 2){   //点击的是第一条或者最后一条
                    if(newIdx == 0){    //第一条
                        this.upObj = {}                 //上一篇新闻内容
                        this.currentObj = res.data[0]   //当前新闻内容
                        this.downObj = res.data[1]      //下一篇新闻内容
                    }else if(newIdx == 1){  //最后一条
                        this.upObj = res.data[0]        //上一篇新闻内容
                        this.currentObj = res.data[1]   //当前新闻内容
                        this.downObj = {}               //下一篇新闻内容
                    }
                }else if(res.data.length == 3){ //点击的新闻上下都有
                        this.upObj = res.data[0]        //上一篇新闻内容
                        // res.data[1].newsContent = res.data[1].newsContent
                        this.currentObj = res.data[1]   //当前新闻内容
                        this.downObj = res.data[2]      //下一篇新闻内容
                }else{  //当前只有一条数据
                    this.upObj = {}                 //上一篇新闻内容
                    this.currentObj = res.data[0]   //当前新闻内容
                    this.downObj = {}               //下一篇新闻内容
                }
            }else{
                this.upObj = {}                 //上一篇新闻内容
                this.currentObj ={}             //当前新闻内容
                this.downObj = {}               //下一篇新闻内容
            }
            if(num == 2){
                this.GoTop(600)
            }
        }
    },
    async created(){
        this.id = this.$route.query.id
        // 根据id查询新闻详情
        this.selectNewsId(this.id,2)
    }
};
</script> 

<style lang="scss" scoped>
// 顶部图片
.topImg{
    background: url(../../assets/img/xinwen.jpg);
}
// 
.newsContentDiv{
    padding:50px 270px;
    background: #ECECEC;
    // 内容
    .newsContentInfo{
        background: #ffffff;
        border-radius: 10px;
        padding:50px 40px;
    }
    // 面包屑
    .newsCrumbs{
        margin-left: -10px;
        .nct{
            padding:0px 10px;
            border-right: 1px solid #E1E1E1;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400; 
            color: #666666;
            a{
                transition: .2s;
            }
        }
        .ahref:hover{
            a{
                color:#7492D7 !important;
            }
        }
        .nct:last-child{
            border-right: 0px solid #E1E1E1;
        }
    }
    // 时间
    .news{
        padding:70px;
        div{
            padding-bottom: 30px;
            border-bottom: 1px solid #D0D0D0;
            span{
                font-size: 14px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #c6c6c6;
            }
            .nleft{
                margin-left: 70px;
            }
        }
    }
    // 文章
    .newsContent{
        padding:0px 70px 70px 70px;
        .title{
            font-size: 30px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            text-align: center;
            color: #444444;
        }
        .content{
            margin-top: 50px;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #555555;
            line-height: 32px;
        }
        .pages{
            display: flex;
            justify-content: space-between;
            margin-top: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: center;
            color: #b9b9b9;
            .pagesColor{
                color:#7492d7;
                cursor: pointer;
            }
        }

    }
}
</style>